const deepFreeze = (t) => (Object.keys(t).forEach((n) => {
	typeof t[n] == "object" && !Object.isFrozen(t[n]) && deepFreeze(t[n]);
}), Object.freeze(t));
var clone = (e) => JSON.parse(JSON.stringify(e)), createSelector = (e) => (t) => e.split(".").reduce((e, t) => {
	if (e) return e[t];
}, t);
const createMemoizedSelector = (e, t) => {
	let r, i, a = typeof e == "string" ? createSelector(e) : e;
	return (e) => {
		let n = a(e);
		if (n == null) {
			i = void 0, r = void 0;
			return;
		}
		let o = JSON.stringify(n);
		return JSON.stringify(r) !== o && (i = t(n), r = JSON.parse(o)), i;
	};
};
function createStore(r) {
	let i = { ...r }, a = /* @__PURE__ */ new Set(), o = () => deepFreeze(clone(i)), s = (e) => {
		let t = typeof e == "function" ? e(i) : e;
		if (t instanceof Promise) throw Error("The selector can not return a Promise. If you want to use a async action selector please provide a function that returns a async operation.");
		d(t, h(""));
	}, c = (e, t) => {
		let r = {
			selector: typeof e == "string" ? createSelector(e) : e,
			selectorKey: typeof e == "string" ? e : e.name,
			callback: t
		};
		return a.add(r), () => a.delete(r);
	}, l = (e) => typeof e == "string" ? createSelector(e)(i) : e(i), u = (e, t, n, r) => {
		let i = h(e, t, void 0, n, r);
		m(i);
	}, d = (e, t) => {
		t.executionEnd = Date.now(), t.emitStart = t.executionEnd;
		let n = { ...i };
		i = { ...e }, a.forEach((e) => {
			let t = e.selector(n), r = e.selector(i);
			t !== r && e.callback(r, t);
		}), t.emitEnd = Date.now(), t.usedTime = t.emitEnd - t.executionStart, t.onFullfilled && t.onFullfilled(i);
	}, f = (e, t) => {
		let n = { ...i }, r = e(n, t);
		if (r instanceof Promise) throw Error("The selector can not return a Promise. If you want to use a async action selector please provide a function that returns a async operation.");
		return typeof r == "function" ? r(o, t) : {
			...n,
			...e(n, t)
		};
	}, p = (e, t) => {
		let n = e.split("."), r = (e, t) => {
			if (e == null) return `
					...state,
					${t < n.length ? r(n[t], t++) : ""}
				`;
			if (t == n.length - 1) return `"${e}": value`;
			let a = n.filter((e, n) => n <= t), o = "next" + n.filter((e, n) => n <= t).map((e) => "[\"" + e + "\"]").join(""), s = a.reduce((e, t) => {
				if (e != null) return e[t];
			}, i);
			return (s == null || Array.isArray(s) || typeof s != "object") && (o = "{}"), `"${e}": {
				...${o},
				${t < n.length - 1 ? r(n[++t], t) : ""}
			}`;
		}, a = `
		const next = {...state};
		

		
		return {
			${r(void 0, 0)}
		}`;
		return Function("state", "value", a)(i, t);
	}, m = (e) => {
		try {
			let { selector: t, payload: n } = e;
			e.timestamp = Date.now(), e.executionStart = e.timestamp;
			let r;
			typeof t == "function" ? r = f(t, n) : typeof t == "string" && (r = p(t, n)), r instanceof Promise ? r.then((t) => {
				e.result = t, d({
					...o(),
					...t
				}, e);
			}) : (e.result = n, d(r, e));
		} catch (e) {
			throw e;
		}
	}, h = (e, t, n, r, i) => {
		let a = (/* @__PURE__ */ Error()).stack;
		return {
			name: n || (typeof e == "string" ? e : a.split("\n")[1].trim()),
			trace: a.split("\n").slice(1, a.split("\n").length).join("\n").trim(),
			selector: e,
			payload: t,
			emitEnd: 0,
			emitStart: 0,
			executionEnd: 0,
			executionStart: 0,
			usedTime: 0,
			...r || {},
			onFullfilled: i
		};
	};
	return {
		getState: o,
		setState: s,
		on: c,
		get: l,
		set: u,
		createAction: (e, t) => function(n, r, i) {
			let a = h(t, n, e, r, i);
			m(a);
		},
		__getInternalState: () => i
	};
}
export { createMemoizedSelector, createStore };
